import { NachrichtenBody } from "./NachrichtenBody";
import { NachrichtenCancel } from "./NachrichtenCancel";
import { NachrichtenNotiz } from "./NachrichtenNotiz";
import NachrichtenNotizBearbeiten from "./NachrichtenNotizBearbeiten";
import { NachrichtenProcessing } from "./NachrichtenProcessing";

const Body = NachrichtenBody;
const Note = NachrichtenNotiz;
const Processing = NachrichtenProcessing;
const Cancel = NachrichtenCancel;
const EditNote = NachrichtenNotizBearbeiten;

export default { Body, Note, Processing, Cancel, EditNote };
